/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Perks_Unit_Reactions_ReceivedInputs */



/**
* | output |
* | --- |
* | "reactions received" |
*
* @param {Perks_Unit_Reactions_ReceivedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_unit_reactions_received = /** @type {((inputs?: Perks_Unit_Reactions_ReceivedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Unit_Reactions_ReceivedInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("полученных реакций")
	return /** @type {LocalizedString} */ ("reactions received")
});